module.exports = __webpack_public_path__ + "ic_content_copy_black_24px.svg?2770a54e21eb22db79feb0758fdd8876";